
export function isValid(data) {
    return data !== undefined && data !== null && data !== ''
}

export function isTrimValid(data) {
    return data !== undefined && data !== null && data !== '' && data.trim() !== ''
}

export function objectValid(data) {
    return data !== undefined && data !== null
}

export function isObjectValid(data) {
    return data !== undefined && data !== null && Object.keys(data).length
}

export function containsKey(obj, key) {
return Object.keys(obj).includes(key)
}

export function isObjectKeyValid(data, key) {
    return data !== undefined && data !== null && Object.keys(data).includes(key)
}

export function isObjectKeyValidAndNotNull(data, key) {
    return data !== undefined && data !== null && Object.keys(data).includes(key) && data[key] !== undefined && data[key] !== null;
}

export function anyArrayObjectValid(data) {
    return data !== undefined && data !== null && data.length > 0
}

export function anyPagingArrayObjectValid(data) {
    return data !== undefined && data !== null && data.items !== undefined && data.items !== null && data.items.length > 0  
}